var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChartIcon = function SvgChartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 25,
    fill: "none",
    viewBox: "0 0 32 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--c-basic-black)",
    strokeWidth: 1.333,
    d: "m1.333 16.667 9.334-9.334L17.333 14 30.667.667m0 0h-9.334m9.334 0V10M0 24.667h31.999"
  })));
};
export default SvgChartIcon;